/**
 * Zone Stats Component
 * Display zone statistics
 */

import { Card } from '../ui';
import { Package, Users, Route } from 'lucide-react';

interface ZoneStatsProps {
  stats: {
    taskCount: number;
    driverCount: number;
    activeRouteCount: number;
  } | null;
  isLoading?: boolean;
}

export default function ZoneStats({ stats, isLoading }: ZoneStatsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 gap-3">
        {[...Array(3)].map((_, i) => (
          <Card key={i} padding="sm">
            <div className="animate-pulse">
              <div className="h-4 w-16 bg-gray-200 rounded mb-2" />
              <div className="h-6 w-10 bg-gray-200 rounded" />
            </div>
          </Card>
        ))}
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <div className="grid grid-cols-3 gap-3">
      <Card padding="sm">
        <div className="flex items-center gap-2">
          <Package className="h-4 w-4 text-blue-500" />
          <span className="text-sm text-gray-600">Tasks</span>
        </div>
        <p className="text-xl font-bold text-gray-900 mt-1">{stats.taskCount}</p>
      </Card>

      <Card padding="sm">
        <div className="flex items-center gap-2">
          <Users className="h-4 w-4 text-green-500" />
          <span className="text-sm text-gray-600">Drivers</span>
        </div>
        <p className="text-xl font-bold text-gray-900 mt-1">{stats.driverCount}</p>
      </Card>

      <Card padding="sm">
        <div className="flex items-center gap-2">
          <Route className="h-4 w-4 text-purple-500" />
          <span className="text-sm text-gray-600">Routes</span>
        </div>
        <p className="text-xl font-bold text-gray-900 mt-1">{stats.activeRouteCount}</p>
      </Card>
    </div>
  );
}
